import { Toaster as Sonner, type ToasterProps } from 'sonner';

function Toaster(props: ToasterProps) {
  return (
    <Sonner
      theme="system"
      className="toaster group"
      // On a phone, a toast placed at the top sits just under the 48px page
      // header instead of covering it. Bottom and side offsets keep sonner's
      // 16px default.
      mobileOffset={{ top: 'calc(env(safe-area-inset-top, 0px) + 56px)' }}
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
          description: 'group-[.toast]:text-muted-foreground',
        },
      }}
      {...props}
    />
  );
}

export { Toaster };
